import styled from '@emotion/styled';

import { forMobile } from '@/design-system';

export const HeaderPageWrapper = styled('header')(({ theme }) => ({
  padding: `${theme.spacing[16]}px ${theme.spacing[24]}px 0`,

  [forMobile]: {
    padding: `${theme.spacing[16]}px ${theme.spacing[16]}px 0`,
  },
}));
